import { ERROR_KEYS, ERROR_MESSAGES } from '../constants';

export function getTransformedError({ response }: { response: any }) {
  if (response.errorSummary) {
    return ERROR_MESSAGES[response.errorSummary] || response.errorSummary;
  }
  return ERROR_MESSAGES[ERROR_KEYS.GENERIC_INTERNAL_ERROR];
}

export function getLocalizedString(key: string) {
  return config.i18n[config.language][key];
}
